export const template = [
  {
    accountId: "pdd*****1762",
    index: 1,
    size: "76*130",
    templateName: "中通_拼多多_官方两联",
    company: "zhongtong",
  },
  {
    accountId: "pdd*****1762",
    index: 2,
    size: "76*130",
    templateName: "中通_拼多多_官方一联",
    company: "zhongtong",
  },
  {
    accountId: "pdd*****1762",
    index: 3,
    size: "76*130",
    templateName: "圆通_拼多多_官方两联",
    company: "yuantong",
  },
  {
    accountId: "pdd*****1762",
    index: 4,
    size: "76*130",
    templateName: "申通_拼多多_官方两联",
    company: "shentong",
  },
  {
    accountId: "pdd*****1762",
    index: 5,
    size: "76*130",
    templateName: "韵达_拼多多_官方两联",
    company: "yunda",
  },
];
